import { render, staticRenderFns } from "./ChargebackRemoteAccess.vue?vue&type=template&id=1641eb1c"
import script from "./ChargebackRemoteAccess.vue?vue&type=script&lang=js"
export * from "./ChargebackRemoteAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports